import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ConfigDefinitions } from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { ValidatorService } from "@app/services/validator.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import * as moment from "moment"

@Component({
	selector: "row",
	imports: [COMMON_IMPORTS, GenInputComponent, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="d-flex justify-content-between">
			<app-gen-input
				[actualObj]="this"
				fieldName="num"
				[errors]="errors"
				min="1"
				type="number"
				title_ph_lang="test-scheduler"
				(changeEvent)="handleChange()"
				(keyupEvent)="handleChange()"
			/>
			<div class="form-control">{{ date }}</div>
			@if (id > 1) {
				<div class="btn">
					<button
						class="btn btn-delete"
						(click)="removeRow()"
					>
						{{ "remove" | langVal }}
					</button>
				</div>
			}
		</div>
	`,
})
export class Row {
	@Input() id: number
	@Input() num: number
	@Input() date: string
	@Output() onRemove = new EventEmitter()
	@Output() onChange = new EventEmitter()
	@Output() onError = new EventEmitter()
	errors: any = {}

	constructor(public validator: ValidatorService) {}
	handleChange() {
		this.validator.validateField(this, this.errors, "num", {
			is_positive: true,
		})
		const hasError = this.errors?.num
		this.onError.emit(hasError)
		if (!hasError) {
			this.onChange.emit(this.num)
		}
	}
	removeRow() {
		this.onRemove.emit()
	}
}

@Component({
	selector: "days",
	imports: [COMMON_IMPORTS, Row],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@for (row of arr; track row.id) {
			<row
				[num]="row.num"
				[id]="row.id"
				[date]="dayRowsDates[row.id]"
				(onRemove)="removeRow(row.id)"
				(onChange)="handleChange(row, $event)"
				(onError)="onError.emit($event)"
			/>
		}
	`,
})
export class DaysComponent {
	@Input() arr: any[]
	@Input() initDate: string = ""
	@Output() onChange = new EventEmitter()
	@Output() onError = new EventEmitter()
	dayRowsDates: any = {}

	removeRow(removedId: number) {
		const newArr: any[] = []
		this.arr.forEach(({ id, num }) => {
			if (id === removedId) {
				return
			}
			newArr.push({
				id: newArr.length + 1,
				num,
			})
		})
		this.onChange.emit(newArr)
	}
	ngOnChanges() {
		this.populateDaysArrRows()
	}
	populateDaysArrRows() {
		this.dayRowsDates = {}
		if (!this.initDate) {
			return
		}
		const mom = moment.utc(this.initDate)
		this.arr.forEach(({ id, num }) => {
			mom.add(num, "days")
			this.dayRowsDates[id] = mom.format(ConfigDefinitions.momentDateDisplay)
		})
	}
	handleChange(row: any, value: any) {
		row.num = value
		this.onChange.emit([...this.arr])
	}
}
